import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {IconGreyDot, IconOk} from '../../components/icons/Icon';

type PasswordStrengthIndicatorProps = {
    onValidate: (valid: boolean) => void
    password: string
    passwordRepetition: string
}

const PasswordStrengthIndicator = (props: PasswordStrengthIndicatorProps) => {
    const [t] = useTranslation();
    const [longEnough, setLongEnough] = useState<boolean>(false);
    const [containsLowerAndUpperCase, setContainsLowerAndUpperCase] = useState<boolean>(false);
    const [containsSpecialCharacters, setContainsSpecialCharacters] = useState<boolean>(false);

    useEffect(() => {
        const isLongEnough = !!props.password && props.password.length >= 8;
        const doesContainBothCases = !!props.password && props.password.match(/[a-z]+/) !== null && props.password.match(/[A-Z]+/) !== null;
        const doesContainSpecialCharacters = !!props.password && props.password.match(/[@#$!%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]+/) !== null;

        setLongEnough(isLongEnough);
        setContainsLowerAndUpperCase(doesContainBothCases);
        setContainsSpecialCharacters(doesContainSpecialCharacters);

        props.onValidate(isLongEnough && doesContainBothCases && doesContainSpecialCharacters && props.password === props.passwordRepetition);
    }, [props]);

    return (
        <ul className="strength-indicator">
            <li>
                {longEnough ? <IconOk id="password-long-enough-ok"/> : <IconGreyDot/>}
                {t('forgotPassword.LONG_ENOUGH')}
            </li>
            <li>
                {containsLowerAndUpperCase ? <IconOk id="password-lower-and-upper-case-ok"/> : <IconGreyDot/>}
                {t('forgotPassword.LOWER_AND_UPPER_CASE')}
            </li>
            <li>
                {containsSpecialCharacters ? <IconOk id="password-special-characters-ok"/> : <IconGreyDot/>}
                {t('forgotPassword.SPECIAL_CHARACTERS')}
            </li>
        </ul>
    );
};

export default PasswordStrengthIndicator;
